import * as types from '../types';

export function searchAuthType(text) {
  return {
    type: types.SEARCH_AUTH_TYPE,
    text
  };
}

export function setDeviceType(data) {
  return {
    type: types.SET_DEVICE_TYPE,
    data
  };
}

export function setConfig(config, params) {
  return {
    type: types.SET_CONFIG,
    config,
    params
  };
}

export function setLocalization(localization) {
  return {
    type: types.SET_LOCALIZATION,
    localization
  };
}

export function setVersion(version) {
  return {
    type: types.SET_VERSION,
    version
  };
}

export function setIsOauth2(is_oauth2) {
  return {
    type: types.SET_IS_OAUTH2,
    is_oauth2
  };
}

export function enableAnalytics(enable) {
  return {
    type: types.SET_ANALYTICS,
    enableAnalytics: enable
  };
}

export function notIFrame() {
  return {
    type: types.NOT_IFRAME
  };
}

export function setCDN(url) {
  return {
    type: types.SET_CDN,
    cdn: url
  };
}

export function setAPI(login, mfa) {
  return {
    type: types.SET_API,
    api: login,
    mfa
  };
}

export function setMerchantAPI(merchantApi) {
  return {
    type: types.SET_MERCHANT_API,
    merchantApi
  };
}

export function setBlockHeight(height) {
  return {
    type: types.SET_BLOCK_HEIGHT,
    height
  };
}

export function setPrivacyLink(link) {
  return {
    type: types.SET_PRIVACY_LINK,
    link
  };
}

export function setConsentLink(link) {
  return {
    type: types.SET_CONSENT_LINK,
    link
  };
}

export function setCookieLink(link) {
  return {
    type: types.SET_COOKIE_LINK,
    link
  };
}

export function setTosLink(link) {
  return {
    type: types.SET_TOS_LINK,
    link
  };
}



// WEBPACK FOOTER //
// ./actions/xl.js